import { render, staticRenderFns } from "./PzDirection.vue?vue&type=template&id=87144182&scoped=true&"
import script from "./PzDirection.vue?vue&type=script&lang=js&"
export * from "./PzDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87144182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87144182')) {
      api.createRecord('87144182', component.options)
    } else {
      api.reload('87144182', component.options)
    }
    module.hot.accept("./PzDirection.vue?vue&type=template&id=87144182&scoped=true&", function () {
      api.rerender('87144182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/PzDirection.vue"
export default component.exports